import type { GuideStep } from '../types';

export const WELCOME_STEPS: GuideStep[] = [
  {
    id: 'welcome-1',
    page: 'index',
    section: 'welcome',
    target: 'topbar',
    title: { sv: 'Toppraden', en: 'The top bar' },
    body: {
      sv: 'Här hittar du alla åtgärder på hög nivå: spara, ladda, exportera, ångra/gör om och AI-assistenten.',
      en: 'This is where high-level actions live: save, load, export, undo/redo and the AI assistant.',
    },
    placement: 'bottom',
    order: 1,
  },
  {
    id: 'welcome-2',
    page: 'index',
    section: 'welcome',
    target: 'tool-sidebar',
    title: { sv: 'Verktygspanelen', en: 'The tool sidebar' },
    body: {
      sv: 'Här finns block du kan dra ut på canvasen. Vi har anpassat namn och ikoner efter vad du valde att bygga.',
      en: 'Here are the blocks you can drag onto the canvas. We tailored the names and icons based on what you chose to build.',
    },
    placement: 'right',
    order: 2,
  },
  {
    id: 'welcome-3',
    page: 'index',
    section: 'welcome',
    target: 'canvas',
    title: { sv: 'Canvasen', en: 'The canvas' },
    body: {
      sv: 'Detta är din arbetsyta. Du kan panorera, zooma och placera block var du vill. Rutnätet snappar till 20 px.',
      en: 'This is your workspace. Pan, zoom and place blocks anywhere. The grid snaps to 20 px.',
    },
    placement: 'auto',
    order: 3,
  },
  {
    id: 'welcome-4',
    page: 'index',
    section: 'welcome',
    target: 'block',
    fallbackTargets: ['layer-card', 'canvas'],
    mobileTarget: null,
    title: { sv: 'Markera ett block', en: 'Select a block' },
    body: {
      sv: 'Klicka på det highlightade blocket på canvasen. Då öppnas egenskapspanelen till höger automatiskt.',
      en: 'Click the highlighted block on the canvas. The properties panel on the right will open automatically.',
    },
    // Accept any block-style click so layer cards (which now dispatch
    // block:click too) also advance this step. Show me how uses a
    // comma-separated selector so the cursor finds whichever element
    // type exists on the user's canvas.
    advanceOn: { kind: 'click' },
    showMeHow: {
      steps: [
        { selector: '[data-guide="block"], [data-guide="layer-card"]', action: 'click', label: 'Click', hold: 700 },
      ],
      durationMs: 2500,
    },
    placement: 'auto',
    order: 4,
  },
  {
    id: 'welcome-4b',
    page: 'index',
    section: 'welcome',
    target: 'properties',
    mobileTarget: null,
    title: { sv: 'Egenskapspanelen', en: 'The properties panel' },
    body: {
      sv: 'Nu är panelen öppen med blockets inställningar: namn, beskrivning, färg och mer.',
      en: "The panel is now open with the block's settings — name, description, color and more.",
    },
    placement: 'left',
    order: 4.5,
  },
  {
    id: 'welcome-5',
    page: 'index',
    section: 'welcome',
    target: 'properties-name',
    fallbackTargets: ['properties'],
    mobileTarget: null,
    title: { sv: 'Namnfältet', en: 'The name field' },
    body: {
      sv: 'Ge varje block ett tydligt namn. Namnet visas på blocket och i AI-prompten.',
      en: 'Give each block a clear name. The name shows on the block and in the AI prompt.',
    },
    placement: 'left',
    order: 5,
  },
  {
    id: 'welcome-6',
    page: 'index',
    section: 'welcome',
    target: 'properties-color',
    fallbackTargets: ['properties'],
    mobileTarget: null,
    title: { sv: 'Färg', en: 'Color' },
    body: {
      sv: 'Välj en färg för att gruppera block visuellt — t.ex. rött för fel, grönt för lyckat utfall.',
      en: 'Pick a color to group blocks visually — e.g. red for errors, green for success.',
    },
    placement: 'left',
    order: 6,
  },
  {
    id: 'welcome-7',
    page: 'index',
    section: 'welcome',
    target: 'minimap',
    mobileTarget: null,
    title: { sv: 'Minikartan', en: 'The minimap' },
    body: {
      sv: 'Längst ner i högerpanelen ser du hela workflowet ovanifrån. Klicka var som helst för att hoppa dit.',
      en: 'At the bottom of the right panel, see the whole workflow from above. Click anywhere to jump there.',
    },
    placement: 'left',
    order: 7,
  },
];
